<template>
    <div>
        <table class="table table-hover payment-transaction-list">
            <colgroup>
                <col/>
                <col/>
                <col class="gary" />
            </colgroup>
            <thead>
            <tr>
                <th></th>
                <!--<th>{{$t('deposit_transaction.transactions')}}</th>-->
                <th class="amount-th">{{$t('deposit_transaction.amount')}}</th>
                <th class="amount-th">{{$t('deposit_transaction.paid')}}</th>
            </tr>
            </thead>
            <tbody id="transactions_wrapper" v-if="!loading_transaction_data">
            <template v-for="(t_row, index) in transaction_data['transactions']">
                <tr :key="index" :class="t_row['neutralized']?'neutralized':''">
                    <td>
                        <div class="t-list-title" v-html="t_row['title']"></div>
                        <div class="t-list-desc">{{t_row['desc']}}</div>
                        <template v-if="t_row['action'] == TransactionAction.DEPOSIT_PAYMENT && !t_row['neutralized']">
                            <v-btn small class="ml-0" @click="voidPayment(t_row['related_id'])">{{$t('action.void')}}</v-btn>
                        </template>
                    </td>
                    <td class="amount-td">
                        <template v-if="t_row['side']==='debit'">
                            {{utils.toCurrencyFormat(t_row['amount'])}}
                        </template>
                    </td>
                    <td class="amount-td">
                        <template v-if="t_row['side']==='credit'">
                            {{utils.toCurrencyFormat(t_row['amount'])}}
                        </template>
                    </td>
                </tr>
            </template>
            <tr class="total">
                <td class="total-label">{{$t('deposit_transaction.total')}}</td>
                <td class="amount-td">{{utils.toCurrencyFormat(transaction_data['total'])}}</td>
                <td class="amount-td">{{utils.toCurrencyFormat(transaction_data['deposit_paid'])}}</td>
            </tr>
            </tbody>
        </table>

        <v-dialog v-model="pay_deposit_dialog.show" scrollable persistent max-width="600px">
            <v-form ref="add_payment_form" method="post" :action="form.action" v-model="form.valid" v-on:success="successAddPayment">
                <v-card>
                    <v-card-title
                            class="headline blue darken-2 white--text"
                            primary-title
                    >
                        <div>{{$t('deposit_transaction.add_payment')}}</div>
                    </v-card-title>
                    <v-card-text>

                        <input type="hidden" name="registration_id" v-model="registration_id">

                        <v-card class="elevation-0">
                            <v-card-text>

                                <v-container grid-list-md class="pa-0">
                                    <v-layout wrap>

                                        <v-flex xs12>
                                            <v-text-field
                                                :label="$t('deposit_transaction.amount')"
                                                prefix="$"
                                                v-model="form.data.amount"
                                                :rules="[rules.required]"
                                                :error-messages="form.errors.amount"
                                                name="amount"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <label class="v-label sp-v-label">{{$t('deposit_transaction.payment_method')}}</label>
                                            <v-radio-group row
                                                           class="mt-2"
                                                           :rules="[rules.required]"
                                                           :error-messages="form.errors.payment_method"
                                                           v-model="form.data.payment_method"
                                            >
                                                <template v-for="(payment_method_val) in payment_methods">
                                                    <v-radio :key="payment_method_val" :label="$t('payment_methods.' + payment_method_val)" name="payment_method" :value="payment_method_val"></v-radio>
                                                </template>
                                            </v-radio-group>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field
                                                    :label="$t('deposit_transaction.payment_ref')"
                                                    v-model="form.data.payment_ref"
                                                    name="payment_ref"
                                            ></v-text-field>
                                        </v-flex>

                                    </v-layout>
                                </v-container>

                            </v-card-text>
                        </v-card>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="pay_deposit_dialog.show = false">{{$t('action.close')}}</v-btn>
                        <v-btn color="blue darken-1" flat type="submit" :loading="form.loading">{{$t('action.add')}}</v-btn>
                    </v-card-actions>

                </v-card>
            </v-form>
        </v-dialog>

        <div v-if="show_payment_button" class="text-xs-right">
            <v-btn class="mr-0" color="primary" @click="showAddPaymentDialog">{{$t('deposit_transaction.add_payment')}}</v-btn>
        </div>
    </div>

</template>

<script>
    import TransactionAction from '~/components/enum/registration/TransactionAction.ts'
    import PaymentMethod from '~/components/enum/registration/PaymentMethod.ts'
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from '~/utils/url-manager'
    import FormHandling from "~/utils/data/form-handling"
    import Utils from '~/utils';

    export default {
        name: "DepositTransactionView",
        props: {
            registration_id: Number,
            default_payment_method: {
                type: Number,
                default: null
            },
            default_payment_reference: String,
            after_action: {
                type: Function,
                default: function() {}
            }
        },
        data() {
            return {
                utils: Utils,
                rules: {
                    required: value => (!!value || parseInt(value)===0) || this.$t('form.field_required')
                },
                show_payment_button: false,
                pay_deposit_dialog: {
                    show: false
                },
                form: {
                    action: UrlServices.createUrl({name: "api_add_payment"}),
                    loading: false,
                    valid: false,
                    errors:{
                        amount: "",
                        payment_method: "",
                    },
                    data: {
                        amount: 0,
                        payment_method: null,
                        payment_ref: null
                    }
                },
                TransactionAction: TransactionAction,
                payment_methods: Utils.getEnumValues(PaymentMethod),
                loading_transaction_data: false,
                transaction_data: {}
            };
        },
        methods: {
            getRegistrationTransactions() {
                let me = this;
                me.loading_transaction_data = true;
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_get_payment_transactions'}), {
                    registration_id: me.registration_id
                }, {
                    'success': function(data) {
                        me.transaction_data = _.extend({}, data);
                        if(data['total'] > 0){
                            me.show_payment_button = true;
                        } else {
                            me.show_payment_button = false;
                        }
                        me.loading_transaction_data = false;
                    }
                });
            },
            showAddPaymentDialog() {
                this.$refs['add_payment_form'].reset();
                this.$nextTick(() => {
                    this.form.data.amount = this.transaction_data.total;
                    this.form.data.payment_method = this.default_payment_method;
                    this.form.data.payment_ref = this.default_payment_reference;
                    this.form.errors.amount = "";
                    this.form.errors.payment_method = "";
                    this.pay_deposit_dialog.show = true;
                });
            },
            successAddPayment() {
                this.getRegistrationTransactions();
                this.after_action();
                this.pay_deposit_dialog.show = false;
            },
            voidPayment(payment_id) {
                let me = this;
                this.$root.$confirm(me.$t('deposit_transaction.void_payment'), me.$t('deposit_transaction.void_payment_msg')).then((confirm) => {
                    if(confirm){
                        RequestHandler.Post(UrlServices.createUrl({'name': 'api_void_payment'}), {
                            payment_id: payment_id
                        }, {
                            'success': function(data) {
                                me.getRegistrationTransactions();
                                me.after_action();
                            },
                            'error': function(data) {

                            }
                        });
                    }
                })

            }
        },
        watch: {
            registration_id: function() {
                if(this.registration_id){
                    this.show_payment_button = false;
                    this.getRegistrationTransactions();
                }
            },
            "form.data.amount": function(new_value) {

                if(new_value > this.transaction_data.total){
                    this.$nextTick(function(){
                        this.form.data.amount = this.transaction_data.total;
                    });
                }
            }
        },
        mounted() {
            new FormHandling(this, "add_payment_form");
            this.getRegistrationTransactions();
        }
    }
</script>

<style>
    .v-label.sp-v-label {
        font-size: 0.9em;
        color: #AAA;
    }

    table.payment-transaction-list {
        width: 100%;
        border: 1px solid #DDD;
        border-collapse: collapse;
    }

    table.payment-transaction-list th, table.payment-transaction-list td {
        padding: 5px;
        text-align: left;
    }

    table.payment-transaction-list th {
        border-bottom: 1px solid #DDD;
    }


    th.amount-th {
        text-align: right!important;
    }

    td.amount-td {
        text-align: right!important;
    }

    .t-list-title {
        font-weight: bold;
    }

    .t-list-desc {
        font-size: 0.8em;
    }

    tr.total {
        border-top: 1px solid #BBB;
    }

    td.total-label {
        font-weight: bold;
    }

    tr.total td.amount-td {
        font-weight: bold;
    }

    tr.neutralized {
        opacity: 0.5;
    }

    .gary {
        background-color: #efefef;
    }
</style>